import { Link } from "react-router-dom";
import CsvImportFlow from "../components/CsvImportFlow";

export default function ImportCsvPage() {
  return (
    <main className="min-h-screen bg-washi px-6 py-10">
      <div className="mx-auto max-w-4xl">
        <Link to="/cards" className="text-sm text-navySoft hover:underline">
          ← 一覧に戻る
        </Link>
        <h2 className="serif mt-4 text-2xl font-medium text-navy">
          CSV インポート
        </h2>
        <p className="mt-2 mb-8 text-sm text-navySoft">
          Eight / CamCard / myBridge / Excel
          で書き出した CSV を読み込んで、Google Sheets
          に追加します。1行目をヘッダ行として自動で項目を紐付け、必要なら手動で修正できます。
        </p>

        <CsvImportFlow />
      </div>
    </main>
  );
}
